import { render, staticRenderFns } from "./TransactionList.vue?vue&type=template&id=24d5e87a&scoped=true"
import script from "./TransactionList.vue?vue&type=script&lang=js"
export * from "./TransactionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d5e87a",
  null
  
)

export default component.exports